import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { HeadingText } from '@paypalcorp/pp-react';
import CategoryToolTile from './CategoryToolTile';

import { AMPLITUDE } from '../../../lib/constants';

const { COLLECTION_APP_TILE_CLICK } = AMPLITUDE;

const CollectionSection = props => {
  const {
    section,
    tools = {},
    toolTileProps,
    fptiClick,
    fptiImpression,
    locationByCategoryKey,
    structuredPSData,
    collection = {}
  } = props;

  useEffect(() => {
    fptiImpression({ pageLink: sectionFptiName, type: fptiLinkName });
  }, []);

  const path = `/appcenter`;
  const { sectionFptiName = '' } = section;
  const { fptiLinkName = '' } = collection;
  const apps = section.apps.split(',');

  const handleClickTool = ({
    fptiLink,
    prod,
    PSUrl,
    categoryRank,
    appKey,
    rank,
    priorityScore
  }) => {
    return () => {
      fptiClick({
        fptiLink,
        pageLink: sectionFptiName,
        type: fptiLinkName,
        prod,
        categoryRank,
        appKey,
        rank,
        priorityScore,
        amplitude: true,
        event_name: COLLECTION_APP_TILE_CLICK
      });
      fetch(PSUrl);
    };
  };

  return (
    <Fragment>
      <div className="collection-section-title">
        <HeadingText level={2} >{section.title}</HeadingText>
      </div>
      <div className="section-tools">
        {apps
          .filter(a => tools[a])
          .map((app, index) => {
            const tool = tools[app];
            const appPath = `${path}/${
              locationByCategoryKey[tool.categoryKey]
            }`;

            return (
              <CategoryToolTile
                key={`collection-tool-item-${index}`}
                handleClickTool={handleClickTool}
                tool={tool}
                path={appPath}
                toolTileProps={toolTileProps}
                fptiClick={fptiClick}
                fptiImpression={fptiImpression}
                structuredPSData={structuredPSData}
                isCollections={true}
                collection={collection}
                section={section}
              />
            );
          })}
      </div>
    </Fragment>
  );
};

CollectionSection.propTypes = {
  section: PropTypes.array,
  collection: PropTypes.array,
  tools: PropTypes.object,
  toolTileProps: PropTypes.object,
  fptiClick: PropTypes.func,
  fptiImpression: PropTypes.func,
  structuredPSData: PropTypes.object,
  locationByCategoryKey: PropTypes.object
};

export default CollectionSection;
